export default __webpack_public_path__ + "static/titre.webp-e5528acf999f3d630aec77c341a0648c.png";